import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ExpandMore } from "@mui/icons-material";
import React from "react";
import "styled-components";
const useAccordionStyles = makeStyles({
  root: {
    marginBottom: "12px",
    boxShadow: "unset",
    border: "0.5px solid #A2ADB2",
    borderRadius: "4px",
    "&::before": {
      background: "#fff",
    },
  },
});
const Accordian = ({ expanded, panel, handleChange, title, children }) => {
  const accordionClasses = useAccordionStyles();
  return (
    <>
      <Accordion
        expanded={expanded}
        onChange={handleChange(panel)}
        classes={accordionClasses}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMore
              className={expanded ? "color-primary" : ""}
            />
          }
          aria-controls={`pane${panel}bh-content`}
          id={`pane${panel}bh-header`}
        >
          <div
            css={`
              color: ${expanded
                ? "var(--primary-color)"
                : "var(--dark-grey-1)"};
              font-size: 18px;
              font-weight: 600;
            `}
          >
            {title}
          </div>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </>
  );
};

export default Accordian;
